<template>
    <div class="common-logo">
        <div class="logo-pic" :class="name"></div>
        <div class="logo-txt">{{ text }}</div>
    </div>
</template>

<script>
export default {
    name: 'CommonLogo',
    props: {
        name: {
            type: String,
            default: ''
        },
        text: {
            type: String,
            default: ''
        }
    }
}
</script>

<style lang="scss" scoped>
.common-logo {
    display: flex;
    align-items: center;
    flex-flow: column;
    justify-content: center;
    user-select: none;

    .logo-pic {
        width: 140px;
        height: 48px;
        background-size: 100% 100%;

        &.translate {
            background-image: url(@/assets/images/common/logo/translate.png);
        }

        &.writing {
            background-image: url(@/assets/images/common/logo/writing.png);
        }

        &.ask {
            background-image: url(@/assets/images/common/logo/ask.png);
        }

        &.search0{
            background-image: url(@/assets/images/common/logo/search.png);
        }

        &.search {
            width: 190px;
            height: 48px;
            background-image: url(@/assets/images/common/logo/search2.png);
        }
    }

    .logo-txt {
        font-family: HYQiHei;
        font-size: 16px;
        font-weight: 400;
        font-style: normal;
        line-height: 16px;
        overflow: hidden;
        margin: 4px 0 0 0;
        text-align: center;
        text-overflow: ellipsis;
        color: #615e83;
    }
}
</style>